import { RadioGroup, useRadioState } from '@vtex/admin-ui'
import { Radio, useWatch } from '@vtex/admin-ui-form'
import { useShippingMethods } from 'hooks'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { ShippingMethodsSelector } from 'ui'
import { ShippingApplyTo, ShippingKeys } from '../../typings'
import { SettingsProps } from '../promotions/RegularForm/RegularEffect/hooks/useGenericComponent'
import { useShippingsRelation } from './hooks/useShippingsRelation'
import messages from './messages'
import styles from './styles'

export function ShippingVariantSelector(props: SettingsProps) {
  const { state } = props

  const { $t } = useIntl()

  const [applyTo, selectedMethods] = useWatch({
    form: state,
    //@ts-ignore: useWatch supports multiple fields, but admin-ui-hooks does not expose it
    name: [ShippingKeys.applyTo, ShippingKeys.selectedMethods],
  })

  const radioState = useRadioState({ defaultValue: applyTo })

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    state.setValue(ShippingKeys.applyTo, e.target.value)

    state.resetField(ShippingKeys.selectedMethods, { defaultValue: [] })
  }

  useEffect(() => {
    if (applyTo != radioState.value) {
      radioState.setValue(applyTo)
    }
  }, [applyTo, radioState])

  useShippingsRelation({ state })

  const showSelector = applyTo === ShippingApplyTo.selected && selectedMethods

  const {
    data: shippingMethodOptions,
    isLoading: loading,
    error,
  } = useShippingMethods()

  return (
    <div className={styles.container}>
      <RadioGroup
        state={radioState}
        label={
          <div className={styles.radioGroup.label}>
            {$t(messages.applyTo.label)}
          </div>
        }
        onChange={handleRadioChange}
      >
        {Object.values(ShippingApplyTo).map((value) => (
          <Radio
            key={value}
            label={$t(messages.applyTo[value])}
            value={value}
          />
        ))}
      </RadioGroup>
      {showSelector && (
        <div className={styles.selector}>
          <ShippingMethodsSelector
            name={ShippingKeys.selectedMethods}
            state={state}
            shippingOptions={shippingMethodOptions}
            loading={loading}
          />
        </div>
      )}
    </div>
  )
}
